<div class="" style="width: 100%;" [ngStyle]="{'height': alto}">
  <mat-card class="tarjetaZone">
    <div class="encabezado">
      <div [ngStyle]="{'font-size': siceHeader}">{{ header }}</div>
    </div>
    <div class="cuerpo">
      @if (iconFirst && showIcon) {
        <div class="icono">
          <mat-icon [ngStyle]="{'color': iconColor || color, 'width': sice, 'height': sice, 'font-size': sice}"
            style="overflow: visible;">{{ icon }}</mat-icon>
        </div>
      }
      <div class="porcentaje" [ngStyle]="{'font-size': siceValue, 'color': color, 'height': sice}">{{ valueStr ? valueStr : value }}</div>
      @if (!iconFirst && showIcon) {
        <div class="icono">
          <mat-icon [ngStyle]="{'color': iconColor || color, 'width': sice, 'height': sice, 'font-size': sice}"
            style="overflow: visible;">{{ icon }}</mat-icon>
        </div>
      }
    </div>
    <div class="pie">
      <div [ngStyle]="{'font-size': siceFooter}" [matTooltip]="footer">{{ footer }}</div>
    </div>
    @if (barColor) {
      <div class="barraSemaforo">
        <div class="barraSemaforoFill"
          [ngStyle]="{'width': barPercent + '%', 'background': 'linear-gradient(90deg, ' + barColor + ', transparent)'}">
        </div>
      </div>
    }
  </mat-card>
</div>